<template>
    <v-container class="d-flex justify-center pa-0">
      <v-card style="padding-left: 20px; padding-right: 20px; padding-top: 10px; border-radius: 10px; margin-top:3px;">
      <v-card
        style="width: 700px; padding: 0; margin-top: 10px; margin-bottom: 10px; border-radius: 10px; "
        class="custom-shadow pa-4"
        elevation="10"
       
      >
        <v-row>
          <v-col>
            <span class="font-weight-bold" style="color: #2e7917; font-size: 17px; font-family: 'Inter', sans-serif;">
              Marketplace Integration
            </span>
  
            <h2 class="font-weight-bold" style="font-family: fields, sans-serif;
font-style: normal;
font-weight: 200;">
              Benefit Allocation Systems’ Cobra Control Services
            </h2>
            <span style="margin-top: 15px; font-family: 'Inter', sans-serif;">
              Complete, turnkey COBRA Administration, seamlessly integrated with your BambooHR account.
            </span>
          </v-col>
        </v-row>
  
        <hr style="border: 1px solid #e0e0e0; margin: 20px 0;">
  
        <v-row style="margin-left:0px; margin-top: 10px;">
            <span class="font-weight-bold" style="color: #2e7917; font-size:25px; font-family: fields, sans-serif;
font-style: normal; font-weight: 700;">Accept Quote & Begin Setup</span>
        </v-row>
       
        <v-row style="margin-top: 20px; margin-left: 35px">
        <span style="font-size: 18px; font-weight: 500; color: #505250; font-family: 'Inter', sans-serif;">
            Click the "Begin Setup" button below, which will require 2 steps:
        </span>
      </v-row>

      <v-row style="margin-top: 20px; margin-left: 65px">
        <span style="font-size: 19px; font-weight: 500; font-weight: bolder; color: black; font-family: fields, sans-serif;
font-style: normal;">
            1. Login to your BambooHR Account
        </span>
        <span style="font-size: 19px; font-weight: 500; color: #505250; margin-left: 19px; font-family: 'Inter', sans-serif;">
            This will begin the authorization to connect your BambooHR account to BAS MyEnroll.com COBRA Platform
        </span>
      </v-row>

      <v-row style="margin-top: 35px; margin-left: 65px">
        <span style="font-size: 19px; font-weight: 500; font-weight: bolder; color: black; font-family: fields, sans-serif;
font-style: normal;">
            2. Follow the guided MyEnroll.com Account Setup
        </span>
        <span style="font-size: 19px; font-weight: 500; color: #505250; margin-left: 19px; font-family: 'Inter', sans-serif;">
            We will collect a bit more information about your COBRA requirements and complete contracting.
        </span>
      </v-row>

<v-row class="justify-center" style="margin-top: 40px; margin-bottom: 60px">
    <v-btn  @click="nextStep" style="background-color: white; color: black; border-radius: 20px; border: 1px solid grey; text-transform: none; font-weight: normal;">
                Get Started
            </v-btn>
      </v-row>


      <v-overlay v-if="second_loading" class="d-flex align-center justify-center">
      <v-progress-circular indeterminate color="#2e7917" size="70"></v-progress-circular>
    </v-overlay>
       
      </v-card>
      <!-- Footer Logos -->
      <v-row style="margin-top: 1px; margin-left:50px" >
          <v-col cols="4">
            <v-img :src="logo1" alt="Company Logo" style="width: 120px; height: auto; margin-bottom: 0px;"></v-img>
          </v-col>
          <v-col cols="4">
            <v-img :src="logo2" alt="Company Logo" style="width: 150px; height: auto; margin-bottom: 0px;"></v-img>
          </v-col>
          <v-col cols="4" class="ma-0">
            <v-img :src="logo3" alt="Company Logo" style="width: 120px; height: auto; margin-bottom: 0px;"></v-img>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </template>
  
  <script>
  export default {
    data() {
      return {
        logo3: require("@/assets/cobra_services.png"),
        logo1: require("@/assets/companylogo.png"),
        logo2: require("@/assets/bamboohr.png"),
        firstName: localStorage.getItem('firstName') || 'User',
        email: localStorage.getItem('email'),
        subdomain: localStorage.getItem('subdomain'),
        second_loading: false,
      };
    },
    //688585d3ff5628de9334827a130a5ff6e6733f17
    methods:{
      nextStep(){
        this.second_loading = true;
    const clientId = 'developer_portal-9e366ea90fd3b98d5b4a61531c48dd3ee2cb6c3c'; 
    const state = Math.random().toString(36).substring(7); 
    const scope = 'openid+legacy.login+email+benefit';
    const redirectUri = `https://www.myenroll.com/web_projects/bamboohr_backend/Bamboohr_sso_page.aspx`;  
    //const redirectUri = `http://localhost/web_projects/bamboohr_backend/Bamboohr_sso_page.aspx`;
    //const redirectUri =  this.methodUrl+`/bamboohr_backend/Bamboohr_sso_page.aspx`; 
    const authUrl = `https://${this.subdomain}.bamboohr.com/authorize.php?request=authorize&state=${state}&response_type=code&scope=${scope}&client_id=${clientId}&redirect_uri=${redirectUri}`;

    window.location.href = authUrl;
      }
    },
  };
  </script>
  
  <style scoped>
  .logo {
    width: 100px;  /* Adjust logo size */
    margin: auto;
  }
  </style>
  